import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { RCUtils } from './../../RCUtils';

import $ from 'jquery';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import GeofenceMap from '../../actions/GeofenceMap';
import { GeofenceGrid } from '../childcomponents/GeofenceGrid';
import { AddGeofence } from '../sharedcomponents/AddGeofence';
import { EditGeofence } from '../sharedcomponents/AddGeofence';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import ReactTooltip from 'react-tooltip'
import UserRights from '../../actions/UserRights';
import { debug } from 'console';
var Config: any = require('../../Config.json');

export interface geofenceMangementState {
    buttonState: boolean;
    fenceTypeCd: string;
    geofenceData: any[];
    filterParams: server.GeofenceSearch;
    GeofencePopupHtml: any;
    GeofencePopupTitle: string;
}

var self;
var fenceIdArray;
var IsTriggered = false;
export default class GeofenceManagement extends React.Component<RouteComponentProps<{}>, geofenceMangementState> {
    constructor(props: any) {
        super(props);
        var geofenceSearch = { FenceTypeCd: "", FenceName: "" };
        this.state = { buttonState: true, fenceTypeCd: "", geofenceData: [], filterParams: geofenceSearch, GeofencePopupHtml: '', GeofencePopupTitle: '' };
        self = this;
        IsTriggered = false;
    }

    updatemyprofilesDimensions() {
        $(".body_container").css('min-height', $(window).height() - 84);
        $(".body_container").css('max-height', $(window).height() - 84);
        $(".GeofenceHeight").css('min-height', $(window).height() - 151);
        $(".GeofenceHeight").css('max-height', $(window).height() - 151);
    }

    componentDidMount() {
        var authRight = RCUtils.CheckAssesRightsOnly('146');
        if (!authRight) { this.props.history.push('/AccessDenied'); } else {
            GeofenceMap.InitializeMap("geofenceMap");

            $("#AddGeofenceMode").hide();
            $("#EditGeofenceMode").hide();
            $("#DeleteGeofenceMode").hide();

            this.updatemyprofilesDimensions();
            window.addEventListener("resize", this.updatemyprofilesDimensions.bind(this));

            GeofenceMap.InitializeDrawingManager();
            if ($("#drawingManager").hasClass("show")) $("#drawingManager").show();
            $("#dvResizeScreen").css("display", "none");
            //this.loadServerGeofences(false);

            setTimeout(() => { this.loadFencesonUI(); }, 500);
        }
    }

    loadFencesonUI() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeofenceCategoryCds');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                if (data.length === 0) {
                    this.setState({ fenceTypeCd: "B" }, () => this.loadServerGeofences(false));

                    if ($("#DeviceFence").hasClass("active"))
                        $('#DeviceFence').removeClass('active');

                    if (!$("#ServerFence").hasClass("active"))
                        $('#ServerFence').addClass('active');
                }
                else if (data.includes('B') && data.includes('D')) {
                    this.setState({ fenceTypeCd: "B" }, () => this.loadServerGeofences(false));

                    if ($("#DeviceFence").hasClass("active"))
                        $('#DeviceFence').removeClass('active');

                    if (!$("#ServerFence").hasClass("active"))
                        $('#ServerFence').addClass('active');
                }
                else if (data.includes('B')) {
                    this.setState({ fenceTypeCd: "B" }, () => this.loadServerGeofences(false));

                    if ($("#DeviceFence").hasClass("active"))
                        $('#DeviceFence').removeClass('active');

                    if (!$("#ServerFence").hasClass("active"))
                        $('#ServerFence').addClass('active');
                }
                else if (data.includes('D')) {
                    this.setState({ fenceTypeCd: "D" }, () => this.loadDeviceGeofences(false));

                    if (!$("#DeviceFence").hasClass("active"))
                        $('#DeviceFence').addClass('active');

                    if ($("#ServerFence").hasClass("active"))
                        $('#ServerFence').removeClass('active');
                }
            });
    }

    drawingModePolygon(element: any) {
        GeofenceMap.SetDrawingMode('polygon', element);
    }
    drawingModeEdit(element: any) {
        GeofenceMap.SetDrawingMode('edit', element);
    }
    drawingModeDelete(element: any) {
        GeofenceMap.SetDrawingMode('erase', element);
    }

    loadServerGeofences(IsDeleted: boolean) {
        $("#globalLoader").show();
        fenceIdArray = [];
        this.state.filterParams.FenceName = "";
        this.state.filterParams.FenceTypeCd = this.state.fenceTypeCd;// "B";
        var filterParams = JSON.stringify(this.state.filterParams);

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeoFences',
            { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GetGeofenceCoordinates[]>)
            .then(geofenceList => {
                geofenceList.forEach(function (fence) {
                    var coordinatesList = [];
                    if (fence.Coordinates.length > 0) {
                        fence.Coordinates.forEach(function (point) {
                            var coordinates = new Microsoft.Maps.Location(point.Latitude, point.Longitude);
                            coordinatesList.push(coordinates);
                        });
                    }
                    fence.FormatedCoordinates = coordinatesList;
                    fenceIdArray.push(fence.Tag);
                });
                this.setState({ geofenceData: geofenceList });
                GeofenceGrid.handleClearFenceId();
                GeofenceMap.BindGeofencePolygons(geofenceList);
                if (IsDeleted)
                    GeofenceMap.EraseMode();
                $("#globalLoader").hide();
            });
    }

    loadDeviceGeofences(IsDeleted: boolean) {
        $("#globalLoader").show();
        fenceIdArray = [];
        this.state.filterParams.FenceName = "";
        this.state.filterParams.FenceTypeCd = this.state.fenceTypeCd;// "D";
        var filterParams = JSON.stringify(this.state.filterParams);

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeoFences', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GetGeofenceCoordinates[]>)
            .then(geofenceList => {
                geofenceList.forEach(function (fence) {
                    var coordinatesList = [];
                    if (fence.Coordinates.length > 0) {
                        fence.Coordinates.forEach(function (point) {
                            var coordinates = new Microsoft.Maps.Location(point.Latitude, point.Longitude);
                            coordinatesList.push(coordinates);
                        });
                    }
                    fence.FormatedCoordinates = coordinatesList;
                    fenceIdArray.push(fence.Tag);
                });
                this.setState({ geofenceData: geofenceList });
                GeofenceGrid.handleClearFenceId();
                GeofenceMap.BindGeofencePolygons(geofenceList);
                if (IsDeleted)
                    GeofenceMap.EraseMode();
                $("#globalLoader").hide();
            });
    }

    static loadGeofences(element: string) {
        $("#globalLoader").show();
        fenceIdArray = [];
        self.state.filterParams.FenceName = "";
        self.state.filterParams.FenceTypeCd = element;
        var filterParams = JSON.stringify(self.state.filterParams);

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeoFences', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GetGeofenceCoordinates[]>)
            .then(geofenceList => {
                geofenceList.forEach(function (fence) {
                    var coordinatesList = [];
                    if (fence.Coordinates.length > 0) {
                        fence.Coordinates.forEach(function (point) {
                            var coordinates = new Microsoft.Maps.Location(point.Latitude, point.Longitude);
                            coordinatesList.push(coordinates);
                        });
                    }
                    fence.FormatedCoordinates = coordinatesList;
                    fenceIdArray.push(fence.Tag);
                });
                self.setState({ geofenceData: geofenceList });
                GeofenceGrid.handleClearFenceId();
                GeofenceMap.BindGeofencePolygons(geofenceList);
                $("#globalLoader").hide();
            });
    }

    geofenceSearchbyFenceName(fenceName: string, gridApiParams: any) {
        $("#globalLoader").show();
        this.clearPanelData();
        this.state.filterParams.FenceTypeCd = this.state.fenceTypeCd;
        this.state.filterParams.FenceName = fenceName;
        var filterParams = JSON.stringify(this.state.filterParams);

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeoFences', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GetGeofenceCoordinates[]>)
            .then(geofenceList => {
                geofenceList.forEach(function (fence) {
                    var coordinatesList = [];
                    if (fence.Coordinates.length > 0) {
                        fence.Coordinates.forEach(function (point) {
                            var coordinates = new Microsoft.Maps.Location(point.Latitude, point.Longitude);
                            coordinatesList.push(coordinates);
                        });
                    }
                    fence.FormatedCoordinates = coordinatesList;
                });
                this.setState({ geofenceData: geofenceList });
                GeofenceMap.BindGeofencePolygons(geofenceList);
                gridApiParams.paginationGoToFirstPage();
                $("#globalLoader").hide();
            });
    }

    static ValidatePolygonGeofence(coords: any, currentMode: any, currentFence: any, GeofencesData: any) {
        var coordinates: any = [];
        for (var i = 0; i < coords.length; i++) {
            var lat_long = coords[i].latitude + " " + coords[i].longitude;
            coordinates.push(lat_long);
        }
        var polygon: any = coordinates.join(","); 
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/ValidateGeofencePolygon', { method: 'POST', body: JSON.stringify((polygon)), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if(data) {
                    var isPolygon = GeofenceMap.pointInPolygon(coords);
                    if (isPolygon)   
                        this.bindGeofencePopup(currentMode, coords, currentFence, GeofencesData);
                    else
                        PopupWindow.showErrorMessage("Alert", "A self-intersecting polygon cannot be used to define a geofence. Please change the polygon accordingly.");
                }
                else
                {
                    PopupWindow.showErrorMessage("Alert","A polygon is invalid or cannot contain duplicate coordinates. Please change the polygon accordingly.");
                    return;
                }                
            });        
    }

    static DeleteCustomerGeofence(currentFence: any, fenceLayer: any, selectedfence: any) {
        $("#globalLoader").show();
        var inputParams: server.GeofenceParams = { FenceTypeCd: '', FenceId: '', FenceName: '', Address: '', Coordinates: [], ActionTypeCd: '', GeofenceCustomerID: '' };
        inputParams.ActionTypeCd = "D";
        inputParams.GeofenceCustomerID = currentFence.GeofenceCustomerID;
        inputParams.FenceTypeCd = currentFence.GeofenceCategoryCd;

        var geofenceParams = JSON.stringify(inputParams);

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/SaveGeoFence', { method: 'POST', body: geofenceParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<string>)
            .then(message => {
                if (message == "Geofence deleted successfully.") {
                    fenceLayer.remove(selectedfence);
                    if (inputParams.FenceTypeCd == 'D')
                        self.loadDeviceGeofences(true);
                    else
                        self.loadServerGeofences(true);
                    //$("#panelCoordinates").html(null);
                }
                else {
                    $("#globalLoader").hide();
                    PopupWindow.showErrorMessage("Alert", message);
                }
            });
    }

    static bindGeofencePopup(currentMode: string, coordinates: any, currentFence: any, GeofencesData: any[]) {
        $("#globalLoader").show();
        IsTriggered = false;
        var latlonArray = [];
        if (coordinates.length > 0) {
            $.each(coordinates, function (index, value) {
                if ((index === (coordinates.length - 1)) || !(latlonArray.indexOf(value.latitude.toFixed(10) + ',' + value.longitude.toFixed(10)) > -1))
                    latlonArray.push(value.latitude.toFixed(10) + ',' + value.longitude.toFixed(10));
            });
        }
        var inputParams: server.GeofenceParams = { FenceTypeCd: '', FenceId: '', FenceName: '', Address: '', Coordinates: [], ActionTypeCd: '', GeofenceCustomerID: '' };
        inputParams.Coordinates = latlonArray;
        inputParams.FenceTypeCd = self.state.fenceTypeCd;
        if (currentFence != null && currentMode == 'edit')
            inputParams.GeofenceCustomerID = currentFence.GeofenceCustomerID;
        var geofenceParams = JSON.stringify(inputParams);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeofenceIntersect', { method: 'POST', body: geofenceParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GetGeofenceCoordinates[]>)
            .then(data => {
                if (data.length > 0) {
                    var intersectFences = '';
                    data.forEach(function (fence) {
                        var GeofenceCatogery = "";
                        if (fence.GeofenceCategoryCd == 'D') GeofenceCatogery = "Device Geofence";
                        if (fence.GeofenceCategoryCd == 'B') GeofenceCatogery = "Server Geofence";
                        if (fence.GeofenceCategoryCd == 'R') GeofenceCatogery = "Region Geofence";
                        intersectFences = intersectFences + "<div class='geofece-confirm flex-container'><div class='one ms-1'>Fence ID: </div><div class='trunc fw-semibold two ms-1' title='" + fence.Tag + "'>" + fence.Tag + "</div>,<div class='three ms-1'>Fence Name: </div><div class='trunc fw-semibold four ms-1' title='" + fence.Name + "'>" + fence.Name + "</div>,<div class='five ms-1'>Geofence Category: </div><div class='fw-semibold ms-1 six' title='" + GeofenceCatogery + "'>" + GeofenceCatogery + "</div></div>";
                    });
                    var confirmMessage = "<div class='flex-container'> <div>The specified geofence overlaps with the following existing geofence(s): </div></div>" + intersectFences + "<div class='flex-container'><div>Continue?</div>";
                    RCNGWindow.ConfirmWindow.showGeofenceConfirmBox(confirmMessage, self.onOKSubmit.bind(this, currentMode, latlonArray, currentFence, GeofencesData, true), self.closeConfirmation.bind(this, currentMode, currentFence));
                    $("#confirmPopUpModel .btn-close").click(function () {
                        if (!IsTriggered) {
                            GeofenceMap.CancelDrawing();
                            if (currentMode == 'edit' && currentFence != null)
                                GeofenceMap.BindGeofencePolygons(self.state.geofenceData);
                        }
                    });
                }
                else
                    self.onOKSubmit(currentMode, latlonArray, currentFence, GeofencesData, false);

                $("#globalLoader").hide();
            });
    }

    closeConfirmation(currentMode: string, currentFence: any) {
        RCNGWindow.ConfirmWindow.close();
        GeofenceMap.CancelDrawing();
        if (currentMode == 'edit' && currentFence != null)
            GeofenceMap.BindGeofencePolygons(self.state.geofenceData);
    }

    onOKSubmit(currentMode: string, coordinates: any, currentFence: any, GeofencesData: any[], IsConfirmationOpened: boolean) {
        if (!IsTriggered) {
            IsTriggered = true;
            if (IsConfirmationOpened)
                RCNGWindow.ConfirmWindow.close();
            if (currentMode == 'edit' && currentFence != null)
                self.renderGeofencePopUpControl('Edit Geofence', coordinates, currentFence, GeofencesData);
            else
                self.renderGeofencePopUpControl('Add Geofence', coordinates, currentFence, GeofencesData);
        }
    }


    bindServerGeofences() {
        GeofenceMap.DisposeDrawingManager();
        //$("#panelCoordinates").html(null);
        $("#AddGeofenceMode").hide();
        $("#EditGeofenceMode").hide();
        $("#DeleteGeofenceMode").hide();
        this.setState({ fenceTypeCd: "B" });

        document.getElementById("DeviceFence").classList.remove("active");
        document.getElementById("ServerFence").classList.add("active");
        GeofenceMap.InitializeDrawingManager();
        setTimeout(() => { self.loadServerGeofences(false) }, 500);
        //this.loadServerGeofences(false);
    }

    bindDeviceGeofences() {
        GeofenceMap.DisposeDrawingManager();
        //$("#panelCoordinates").html(null);
        $("#AddGeofenceMode").hide();
        $("#EditGeofenceMode").hide();
        $("#DeleteGeofenceMode").hide();
        this.setState({ fenceTypeCd: "D" });
       
        document.getElementById("ServerFence").classList.remove("active");
        document.getElementById("DeviceFence").classList.add("active");

        GeofenceMap.InitializeDrawingManager();
        setTimeout(() => { self.loadDeviceGeofences(false) }, 500);
        //this.loadDeviceGeofences(false);
    }

    clearPanelData() {
        GeofenceMap.DisposeDrawingManager();
        //$("#panelCoordinates").html(null);
        $("#AddGeofenceMode").hide();
        $("#EditGeofenceMode").hide();
        $("#DeleteGeofenceMode").hide();

        GeofenceMap.InitializeDrawingManager();
    }
   
    navigateToGeofenceUploadPage() {
        this.props.history.push('/geofencefile');
    }

    renderGeofencePopUpControl(formName: string, coordinates: any, currentFence: any, GeofencesData: any[]) {
        self.setState({ GeofencePopupTitle: '', GeofencePopupHtml: '' });
        self.setState({ GeofencePopupTitle: formName, GeofencePopupHtml: self.bindGeofencePopupData(formName, coordinates, currentFence, GeofencesData) }, () => {
            $('#btnTriggerGeofencePopup').click();
        });
    }

    bindGeofencePopupData(formName: string, coordinates: any, currentFence: any, GeofencesData: any[]) {
        if (formName == 'Add Geofence')
            return <AddGeofence formname={formName} geofenceCoordinates={coordinates} source={"Management"} fenceTypeCd={this.state.fenceTypeCd} closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)} />
        else if (formName == 'Edit Geofence')
            return <EditGeofence formname={formName} geofenceCoordinates={coordinates} currentFence={currentFence} geofencesData={GeofencesData} source={"Management"} fenceTypeCd={this.state.fenceTypeCd} closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)} />
    }

    closeToolBarGridPreferenceModel() {
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    fnCancelDrawing(e) {
        GeofenceMap.CancelDrawing();
        if (this.state.GeofencePopupTitle == 'Edit Geofence')
            GeofenceMap.BindGeofencePolygons(this.state.geofenceData);
    }

    ShowFullMap() {
        $("#Container1").hide();
        $("#Container2").hide();
        $("#Container3").hide();
        $(".GeofenceHeight").css('min-height', $(window).height() - 71);
        $(".GeofenceHeight").css('max-height', $(window).height() - 71);
        //$(".GeofenceHeight").css("border", "none");
        $("#dvFullScreen").css("display", "none");
        $("#dvResizeScreen").css("display", "block");
    }

    MinimizeMap() {
        $("#Container1").show();
        $("#Container2").show();
        $("#Container3").show();
        $(".GeofenceHeight").css('min-height', $(window).height() - 435);
        $(".GeofenceHeight").css('max-height', $(window).height() - 435);
        //$(".GeofenceHeight").css("border", "1px solid #045976");
        $("#dvFullScreen").css("display", "block");
        $("#dvResizeScreen").css("display", "none");
    }

    public render() {

        return <div>
            <div className='innerpages-heading'>Geofence Management</div>
            <div className='body_container'>
                <div id="Container1" className='hstack gap-2'>

                    <div className="btn-group btn-group-dsd" role="group">
                        <input type="radio" className='btn-check' id="ServerFenceRadio" value="B" name="options" checked={this.state.fenceTypeCd == 'B'} />
                        <label id="ServerFence" className="btn btn-outline-secondary" onClick={this.bindServerGeofences.bind(this)}>
                            Server Geofence
                        </label>
                        <input type="radio" className='btn-check' id="DeviceFenceRadio" value="D" name="options" checked={this.state.fenceTypeCd == 'D'} />
                        <label id="DeviceFence" className="btn btn-outline-secondary" onClick={this.bindDeviceGeofences.bind(this)}>
                            Device Geofence
                        </label>

                    </div>

                    <div className='ms-2'>
                        <i className="fa fa-info-circle information-circle" aria-hidden="true" data-tip='' data-for='tooltipGeofence'>
                        </i>
                        <ReactTooltip id='tooltipGeofence' place="right">
                            <span>Device Geofences are uploaded to devices by using the Deployment feature. While Device Geofences may be preferred over Server Geofences because they allow timelier recognition of geofence crossings in the platform, distributing these geofences to devices typically consumes cellular data. The amount of data consumed may be significant in some cases, depending on cellular service plans, number of geofences and number of deployments, but this is not typical. Please contact ORBCOMM Customer Care with any concerns.</span>
                        </ReactTooltip>

                    </div>


                    <div className={UserRights.checkVisibility('161') + ' ms-auto'}>
                        <div>
                            <button className="btn btn-primary" onClick={this.navigateToGeofenceUploadPage.bind(this)}> Upload File </button>
                        </div>
                    </div>

                </div>

                <div className='row mt-3'>
                    <div className='col-md-8'>
                        <div id="drawingManager" className={UserRights.checkVisibility('161')}>

                            <div className="btn-group btn-group-dsd mt-2 ms-2" id="DrawingModes" role="group" aria-label="Basic radio toggle button group">
                               {/* <input type="radio" className="btn-check" name="btnradio" id="DrawPolygonMode" />*/}
                                <label className="btn btn-outline-secondary" id="DrawPolygonMode" title="Add a geofence" onClick={this.drawingModePolygon.bind(this)}> <span className="fas fa-draw-polygon" ></span> </label>

                               {/* <input type="radio" className="btn-check" name="btnradio" id="EditPolygonMode" />*/}
                                <label className="btn btn-outline-secondary" id="EditPolygonMode" title="Edit an existing geofence" onClick={this.drawingModeEdit.bind(this)} > <span className="fas fa-pencil"></span> </label>

                                {/*<input type="radio" className="btn-check" name="btnradio" id="DeletePolygonMode" />*/}
                                <label className="btn btn-outline-secondary" id="DeletePolygonMode" title="Delete an existing geofence" onClick={this.drawingModeDelete.bind(this)}> <span className="fa-regular fa-eraser"></span>  </label>
                            </div>

                            <div className='mapInner-autosuggest' id="searchBoxContainer"> <input type="text" id="txtSearchBox" className="form-control" placeholder="Address, Business, Place, Zip code, etc." /></div>
                            <div id="AddGeofenceMode" className='alert alert-warning mt-2 ms-2'>
                                <ul className='mb-0 ps-3'>
                                    <li>Left click on map to add points (up to 12) for a new geofence polygon</li>
                                    <li>To stop drawing, double-click when creating the last point</li>
                                </ul>
                            </div>
                            <div id="EditGeofenceMode" className='alert alert-warning mt-2 ms-2'>
                                <ul className='mb-0 ps-3'>
                                    <li>Click on a geofence which you want to edit.</li>
                                    <li>Edit the geofence as required.</li>
                                    <li>Once done the modifications, double click on that geofence.</li>
                                    <li>Pop up with "Edit Geofence" title will open, click on submit button.</li>
                                </ul>
                            </div>
                            <div id="DeleteGeofenceMode" className='alert alert-warning mt-2 ms-2'>
                                <ul className='mb-0 ps-3'>
                                    <li>Click on one or more geofences to delete</li>
                                    <li>When done deleting, click on the “delete” button</li>
                                </ul>
                            </div>
                        </div>

                        <div id="geofenceMap" className='GeofenceHeight'> Map </div>

                    </div>
                    <div className='col-md-4' id="Container2">
                        <div className='GeofenceHeight'>
                            <GeofenceGrid geofenceData={this.state.geofenceData} fenceIdArray={fenceIdArray} geofenceSearchbyFenceName={this.geofenceSearchbyFenceName.bind(this)} ></GeofenceGrid>
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerGeofencePopup" data-bs-toggle="modal" className='hidden' data-bs-target="#MangamentMapGeofencePopUp">GridPreference</button>
            <div className="modal fade" role="dialog" id="MangamentMapGeofencePopUp">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.GeofencePopupTitle}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={this.fnCancelDrawing.bind(this)}>&times;</button>

                        </div>
                        <div className="modal-body">
                            {this.state.GeofencePopupHtml}
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}